import Image from "next/image";
import { BsTaxiFrontFill } from "react-icons/bs";
import { FaHotel, FaPassport } from "react-icons/fa6";
import { SiMealie } from "react-icons/si";

export function getCityStayLine(cities) {
  if (!Array.isArray(cities)) return "";
  return cities
    .map((city) => {
      const name =
        city?.city?.cityName ||
        (typeof city?.city === "string" ? city.city : "") ||
        city?.cityName ||
        "";
      const nights = city?.nights;
      if (nights != null && name) return `${nights}N ${name}`;
      return name;
    })
    .filter(Boolean)
    .join(" | ");
}

export function getInclusionTip(id, item = {}, fallbackLabel = "") {
  const defaultLabel =
    fallbackLabel ||
    INCLUSION_ICONS.find((icon) => icon.id === id)?.label ||
    "";

  if (id === "hotel") {
    return { heading: getCityStayLine(item.cities), label: "Hotel" };
  }

  if (id === "flight") {
    return { heading: "", label: defaultLabel || "Flight" };
  }

  return { heading: "", label: defaultLabel };
}

export const INCLUSION_ICONS = [
    { id: "meal", label: "Meal", key: "isMealsIncluded", icon: <SiMealie alt="" /> },
    { id: "transfer", label: "Transfer", key: "isTransferIncluded", icon: <BsTaxiFrontFill alt="" /> },
    { id: "hotel", label: "Hotel", key: "isHotelIncluded", icon: <FaHotel alt="" /> },
    { id: "visa", label: "Visa", key: "isVisaIncluded", icon: <FaPassport alt="" /> },
    { id: "activity", label: "Activity", key: "isActivityIncluded", icon: <Image src={"/assets/icons/activityInclusion.svg"} alt="" height={16} width={16} quality={70} loading="lazy" /> },
    { id: "flight", label: "Flight", key: "isFlightIncluded", icon: <Image src={"/assets/icons/flightInclusion.svg"} alt="" height={16} width={16} quality={70} loading="lazy" /> },
];